import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-new-product',
    templateUrl: './new-product.component.html',
    styleUrls: ['./new-product.component.scss'],
    imports: [TranslateModule]
})
export class NewProductComponent implements OnInit, OnDestroy {
    private appService = inject(AppService);


    productSlides = [];
    productParams = {
        sort: 'startDateTime,ASC',
        page: 0,
        size: 9,
    }

    ngOnInit() {
        this.getProducts()
    }

    ngOnDestroy() {
    }
    getProducts() {
        this.appService.getAll(`planning/public/sellableproducts`, this.productParams).subscribe((response) => {
            if (response._embedded.sellableProductTableDToes) {
                this.productSlides = this.chunkArray(response._embedded.sellableProductTableDToes, 3)
            }
        });
    }
    chunkArray(array, chunkSize) {
        var arrayOfArrays = [];

        if (array.length <= chunkSize) {
            arrayOfArrays.push(array);
        } else {
            for (var i = 0; i < array.length; i += chunkSize) {
                arrayOfArrays.push(array.slice(i, i + chunkSize));
            }
        }
        console.log(arrayOfArrays)
        return arrayOfArrays;
    }
}
